export enum TiposMensaje {
  RECARGAR_SALDO = 'RECARGAR_SALDO',
  ACTUALIZAR_TRANSACCIONES_ASIGNADAS = 'ACTUALIZAR_TRANSACCIONES_ASIGNADAS',
  ACTUALIZAR_USDT = 'ACTUALIZAR_USDT',
  ACTUALIZAR_TASA_FIAT= 'ACTUALIZAR_TASA_FIAT'
}
